export default __webpack_public_path__ + "resources/icons/d112-5ab7.png";